module.exports = __webpack_public_path__ + "img/1508987660.1afe60fa.jpg";